import React, { useEffect, useState } from 'react';
import TableCrud from '../../components/TableCrud';
import Api, { exceptionNotificationAPI } from '../../services/api';

const BranchIndex = () => {

    const columns = [
        {
            label: "Descrição",
            name: "description"
        },
        {
            label: "Empresa",
            name: "tenant.name",
            visible: true
        },
        {
            label: "Ativo",
            name: "isActive"
        },

    ]

    return (
        <TableCrud title={"Filial"} table={"branch"} columns={columns}/>
    );
}

export default BranchIndex;
